angular.module("avant.filters", []);

window.PhoneFormat = window.PhoneFormat || {};
window.PhoneFormat.formatLocal =
  window.PhoneFormat.formatLocal || ((_, phoneNumber) => phoneNumber);

require("./after_date.coffee");
require("./formatted_date.coffee");
require("./left_pad.coffee");
require("imports-loader?formatLocal=>window.PhoneFormat.formatLocal!./locale_phone_number.coffee");
require("./option_value_to_string.coffee");
require("./or_new_date.coffee");
require("./replace_nonnumeric_with_xes.coffee");
require("./ssn.coffee");
require("./stage_to_action.coffee");
require("./stage_to_word_array.coffee");
require("./state.coffee");
require("./product");
